import logReport from '@/util/logReport';
import apiEvent from '@/util/call/apiEvent';
import eventBus from '@/EventBus';
import initKlcns from '@/util/call/klcns/initKlcns';

const state = {};

const getters = {};

const mutations = {};

const checkIsWebsocketConnectAvailable = ({ commit, rootGetters }) => {
  const { IS_CALL_CONNECTED, IS_CALL_CONNECTING, enabledCallAgent, isExistCallAgent, callWebsocketUrl } = rootGetters;

  if (IS_CALL_CONNECTED) return false; // 이미 콜 서버에 연결되어 있으면
  if (IS_CALL_CONNECTING && !IS_CALL_CONNECTED) return false; // 콜 서버에 연결 시도중일 때
  if (!callWebsocketUrl) return false; // 연결할 콜 웹소켓 url이 없으면

  if (!isExistCallAgent) return false; // 존재하지 않는 콜 상담사 계정이면
  if (!enabledCallAgent) return false; // 사용 승인된 콜 상담사 계정이 아니면

  if (!window.sessionStorage.getItem('isCall')) {
    if (!localStorage.getItem('call-info')) return false;
    const { startTime, endTime } = JSON.parse(localStorage.getItem('call-info'));
    if (startTime && !(startTime && endTime)) {
      commit('setIsOverlap', true, { root: true });
      commit('initDimmed', null, { root: true });
      return false;
    }
  }

  return true;
};

const connectWithValidation = ({ commit, dispatch, rootGetters }) => {
  const { isFirstConnect, callWebsocketUrl } = rootGetters;

  if (!isFirstConnect) {
    commit('setIsCallSocketReConnected', true, { root: true });
  }

  commit('START_CALL_CONNECT', null, { root: true });

  if (!isFirstConnect) {
    dispatch('notifySocketReconnection');
  } else {
    commit('setIsFirstConnect', false, { root: true });
  }

  let stompClient = new WebSocket(callWebsocketUrl);
  stompClient.binaryType = 'arraybuffer';
  commit('setSocketClient', stompClient, { root: true });
};

const actions = {
  klcns_connect({ commit, dispatch, rootGetters }) {
    const check = checkIsWebsocketConnectAvailable({ commit, rootGetters });
    if (!check) return;

    connectWithValidation({ commit, dispatch, rootGetters });

    rootGetters.stompClient.onopen = function () {
      initKlcns.resetCount('call');
      dispatch('notifySocketReconnectionSuccess');
      logReport.write('[SOCKET] - OPEN');
      commit('END_CALL_CONNECT', null, { root: true });
      commit('OPEN_CALL', null, { root: true });
      commit('initDimmed', null, { root: true });
    };

    rootGetters.stompClient.onmessage = function (e) {
      if (rootGetters.isOverlap) {
        commit('setIsOverlap', false, { root: true });
        commit('initDimmed', null, { root: true });
      }

      if (rootGetters.isCallSocketReConnected) {
        commit('setIsCallSocketConnected', true, { root: true });
        commit('setIsCallSocketReConnected', false, { root: true });
        commit('initDimmed', null, { root: true });
        logReport.write('[SOCKET] - isCallSocketReConnected');
      }

      const rcvData = JSON.parse(e.data);

      if (rcvData.response === 'Success' && rcvData.code === 205) {
        // 콜 웹소켓 중복 연결 방지용 로직.
        initKlcns.setCount('call', 5);
        commit('setIsOverlap', true, { root: true });
        commit('initDimmed', null, { root: true });
      }

      if (rcvData.response === 'Error' && rcvData.code === 409) {
        initKlcns.setCount('call', 5);
        commit('setIsOverlap', true, { root: true });
        commit('initDimmed', null, { root: true });
      }

      apiEvent.EventProc(rcvData);
    };

    rootGetters.stompClient.onclose = function (event) {
      dispatch('notifySocketReconnectionFail');
      logReport.write('[SOCKET] - CLOSE >', 'code: ', event.code, 'reason:', event.reason, 'wasClean:', event.wasClean);
      commit('FAIL_CALL_CONNECT', null, { root: true });
      eventBus.$emit('call-reconnect-start');
      commit('initDimmed', null, { root: true });
    };

    rootGetters.stompClient.onerror = function (e) {
      logReport.write('[SOCKET] - ERROR');
      console.log(e);
      commit('initDimmed', null, { root: true });
    };
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/klcnsCallWebsocket.js